import { Injectable } from '@angular/core';

import { BefreiungErgebnis } from './../entities/befreiungErgebnis';
import { Befreiung } from './../entities/befreiung';
import { AbstractBefreiungService } from './abstract-befreiung.service';
import { kvNummerIsValid } from '../kvNummerIsValid';
import { Einwilligung } from '../einwilligung';

@Injectable()
export class BefreiungMockService implements AbstractBefreiungService {
    mockBefreiung = {
      KvNummer: '',
      Initialen: 'AZ',
      Befreiungen: [
        new Befreiung( 2016, true),
        new Befreiung( 2017, true) ,
        new Befreiung( 2018, false)
      ]
    };

    getBefreiung(kvNummer: string, einwilligung: Einwilligung): Promise<BefreiungErgebnis> {
      if (!kvNummerIsValid(kvNummer)) {
        return Promise.reject('Ungültige KV-Nummer ' + kvNummer);
      }

      if (kvNummer === 'A111111111') {
        return Promise.reject(
          'Die Sucher ergab keinen Treffer. <br/> <br/>Es liegt keine Zuzahlungsbefreiung vor.');
      }

      this.mockBefreiung.KvNummer = kvNummer;
      return Promise.resolve(this.mockBefreiung);
  }
}



// WEBPACK FOOTER //
// ./src/app/befreiung/shared/services/befreiungMockService.ts